(function ($) {

  $('.question-form-buttons .button').click(function(){
    let index = $('.question-form-buttons .button').index(this);
    //console.log(index)
    $('.question-form-buttons .active').removeClass('active')
    $(this).parent().addClass('active');
    let width = $('.question-form-buttons').width();
    let activeWidth = $('.question-form-buttons .active').outerWidth();
    let widthBefore = $('.question-form-buttons .active').position().left;
    let widthAfter = width - activeWidth - $('.question-form-buttons .active').position().left;
    $('.question-form-buttons .before').width(widthBefore)
    $('.question-form-buttons .after').width(widthAfter)
    $('.question-form').hide();
    $('.question-form:eq('+ index +')').show();
    return false;
  });

  if($('.question-form-buttons').length > 0) {
    $('.question-form:first').show();
    $(window).on('load resize', function(){
      let x = 0;
      let oneRow = true;
      $('.question-form-buttons .button').each(function(){
        let xCurrent = $(this).offset().top;
        //console.log(x +' '+ xCurrent)
        if(x == 0) {
          x = xCurrent;
        }
        if (x !== xCurrent) {
          oneRow = false;
        }
      });
      if(oneRow) {
        $('.question-form-buttons').removeClass('more-rows');
      } else {
        $('.question-form-buttons').addClass('more-rows');
      }
    });

    let buttons = [0,1,2,3];
    
    buttons.forEach(button => {
      if ($('body').hasClass('active-question-form-' + button)) {
        $('.question-form-buttons .button').eq(button).click();
      }
    });
  }

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/question-form.js